var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multiple_stop_black_24dp",
    transform: "translate(0 24) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27045",
    "data-name": "Rectangle 27045",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5139",
    "data-name": "Path 5139",
    d: "M3.79,4.292h3a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-3V.5a.5.5,0,0,0-.85-.35L.15,2.942a.5.5,0,0,0,0,.71l2.79,2.79a.5.5,0,0,0,.85-.36Zm7,0a1,1,0,1,0-1-1A1,1,0,0,0,10.79,4.292Z",
    transform: "translate(6 9)",
    fill: "#f72550"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentDown);
export default __webpack_public_path__ + "static/media/percent_down.f20d8d14fc80301ae2eb604bf506ea87.svg";
export { ForwardRef as ReactComponent };